module.exports = __webpack_public_path__ + "img/gygx_02.81062829.jpg";